export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'Добро пожаловать в MyStorageX',
  'login.description': 'MyStorageX - ваш помощник в облачном хранении, предоставляющий безопасное и удобное хранение и управление файлами. Получите доступ к вашим файлам в любое время и в любом месте.',
  'login.email.placeholder': 'Email или имя пользователя',
  'login.password.placeholder': 'Пароль',
  'login.button': 'Войти',
  'login.loading': 'Вход...',
  'login.divider': 'или',
  'login.signup': 'Нет аккаунта?',
  'login.signup.link': 'Зарегистрироваться',
  'login.error.default': 'Ошибка входа, попробуйте позже',
  'login.success': 'Вход выполнен',
  'login.forgotPassword': 'Забыли пароль?',
  'login.forgotPassword.link': 'Сбросить здесь',
  'signup.page.title': 'Регистрация - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'Добро пожаловать в MyStorageX',
  'signup.description': 'Создайте аккаунт и начните свое путешествие в облачном хранении',
  'signup.username.placeholder': 'Введите имя пользователя',
  'signup.email.placeholder': 'Введите email',
  'signup.password.placeholder': 'Введите пароль',
  'signup.confirmPassword.placeholder': 'Подтвердите пароль',
  'signup.button': 'Зарегистрироваться',
  'signup.loading': 'Регистрация...',
  'signup.login': 'Уже есть аккаунт?',
  'signup.login.link': 'Войти',
  'signup.error.passwordMismatch': 'Пароли не совпадают',
  'signup.error.default': 'Ошибка регистрации, попробуйте позже',
  'signup.success': 'Регистрация завершена',
  'resetPassword.page.title': 'Сброс пароля - MyStorageX',
  'resetPassword.page.description': 'Сбросить пароль вашего аккаунта MyStorageX',
  'resetPassword.title': 'Сброс пароля',
  'resetPassword.email.placeholder': 'Введите ваш email',
  'resetPassword.code.placeholder': 'Введите код подтверждения',
  'resetPassword.password.placeholder': 'Введите новый пароль',
  'resetPassword.button': 'Сбросить',
  'resetPassword.button.loading': 'Сброс...',
  'resetPassword.backToLogin': 'Вернуться к входу',
  'resetPassword.sendCode': 'Получить код',
  'resetPassword.sendCode.sending': 'Отправка...',
  'resetPassword.sendCode.retry': 'Повторить через {seconds}с',
  'resetPassword.error.emailRequired': 'Пожалуйста, введите ваш email',
  'resetPassword.error.codeRequired': 'Пожалуйста, введите код подтверждения',
  'resetPassword.error.passwordRequired': 'Пожалуйста, введите новый пароль',
  'resetPassword.error.passwordLength': 'Пароль должен быть от 6 до 20 символов',
  'resetPassword.error.codeLength': 'Код подтверждения должен состоять из 6 цифр',
  'resetPassword.success.codeSent': 'Код подтверждения отправлен на ваш email',
  'resetPassword.success.reset': 'Пароль успешно сброшен',
  'resetPassword.error.sendFailed': 'Ошибка отправки кода подтверждения, попробуйте позже',
  'resetPassword.error.resetFailed': 'Ошибка сброса пароля, попробуйте позже',
  'signup.username.rule.length': 'Имя пользователя должно быть от 4 до 10 символов',
  'signup.username.rule.format': 'Разрешены только буквы, цифры, подчеркивания и дефисы',
  'signup.password.rule.length': 'Пароль должен быть от 6 до 20 символов',
  'signup.password.rule.lowercase': 'Должен содержать строчные буквы',
  'signup.password.rule.uppercase': 'Должен содержать заглавные буквы',
  'signup.password.rule.number': 'Должен содержать цифры',
  'signup.password.rule.special': 'Должен содержать специальные символы',
  'signup.verificationCode.placeholder': 'Введите код подтверждения',
  'signup.verificationCode.send': 'Получить код',
  'signup.verificationCode.sending': 'Отправка...',
  'signup.verificationCode.retry': 'Повторить через {seconds}с',
  'signup.verificationCode.success': 'Код подтверждения отправлен',
  'signup.verificationCode.error': 'Ошибка отправки кода',
  'signup.verificationCode.required': 'Пожалуйста, введите код подтверждения',
  'signup.verificationCode.invalid': 'Неверный формат кода подтверждения',
  'signup.error.emailRequired': 'Пожалуйста, введите ваш email',
  'signup.announcement': 'Функция регистрации сегодня на техническом обслуживании!',
  'sidebar.allFiles': 'Все файлы',
  'sidebar.starred': 'Избранное',
  'sidebar.folders': 'Папки',
  'sidebar.trash': 'Корзина',
  'sidebar.decrypt': 'Инструмент расшифровки',
  'sidebar.feedback': 'Отзывы',
  'sidebar.about': 'О программе',
  'sidebar.productLog': 'Обновления',
  'filelist.column.name': 'Имя',
  'filelist.column.size': 'Размер',
  'filelist.column.updateTime': 'Изменен',
  'filelist.column.recycletime': 'Дата удаления',
  'filelist.column.actions': 'Действия',
  'filelist.total': 'Всего {total} элементов',
  'filelist.action.upload': 'Загрузить',
  'filelist.action.newFolder': 'Новая папка',
  'filelist.action.refresh': 'Обновить',
  'filelist.action.search': 'Поиск файлов',
  'filelist.action.batchDownload': 'Скачать',
  'filelist.action.batchDelete': 'Удалить',
  'filelist.action.download': 'Скачать',
  'filelist.action.preview': 'Просмотр',
  'filelist.action.rename': 'Переименовать',
  'filelist.selected': 'Выбрано: {count}',
  'page.cloudDrive.title': 'Мой Cloud Drive',
  'page.cloudDrive.description': 'MyStorageX Cloud Drive - Безопасно храните и управляйте вашими файлами',
  'modal.fileUpload.title': 'Загрузка файлов',
  'modal.fileUpload.dragText': 'Перетащите файлы сюда или нажмите для загрузки',
  'modal.fileUpload.start': 'Начать загрузку',
  'modal.fileUpload.cancel': 'Отмена',
  'modal.fileUpload.clear': 'Очистить список',
  'modal.fileUpload.encrypt': 'Зашифровать выбранные',
  'modal.fileUpload.addMore': 'Добавить',
  'modal.fileUpload.remove': 'Удалить',
  'modal.fileUpload.error.noSelection': 'Выберите файлы для удаления',
  'modal.fileUpload.error.noEncryption': 'Выберите файлы для шифрования',
  'modal.fileUpload.error.noClear': 'Нет файлов для очистки',
  'modal.fileUpload.error.noStart': 'Нет файлов для загрузки',
  'modal.fileUpload.error.noCancel': 'Нет активных загрузок для отмены',
  'modal.fileUpload.error.fileSize': 'Превышен размер файла',
  'modal.fileUpload.error.fileType': 'Неподдерживаемый тип файла',
  'modal.fileUpload.error.maxCount': 'Превышено максимальное количество файлов',
  'modal.fileUpload.duplicate.title': 'Файл уже существует',
  'modal.fileUpload.duplicate.skip': 'Пропустить',
  'modal.fileUpload.duplicate.replace': 'Заменить',
  'modal.fileUpload.duplicate.rename': 'Переименовать',
  'modal.fileUpload.status.pending': 'Ожидание',
  'modal.fileUpload.status.uploading': 'Загрузка',
  'modal.fileUpload.status.success': 'Завершено',
  'modal.fileUpload.status.error': 'Ошибка',
  'modal.fileUpload.status.cancelled': 'Отменено',
  'modal.fileUpload.status.duplicated': 'Дубликат',
  'modal.fileUpload.table.filename': 'Имя файла',
  'modal.fileUpload.table.size': 'Размер',
  'modal.fileUpload.table.status': 'Статус',
  'modal.fileUpload.table.progress': 'Прогресс',
  'modal.fileUpload.table.actions': 'Действия',
  'modal.fileUpload.speed': 'Скорость загрузки',
  'modal.fileUpload.remainingTime': 'Осталось времени',
  'modal.fileUpload.total.progress': 'Общий прогресс',
  'modal.fileUpload.error.message': 'Ошибка загрузки: {message}',
  'modal.fileUpload.confirm.clear': 'Очистить список загрузки?',
  'modal.fileUpload.confirm.cancel': 'Отменить загрузку?',
  'modal.fileUpload.clear.mobile': 'Очистить',
  'modal.fileUpload.encrypt.mobile': 'Шифровать',
  'modal.fileUpload.addMore.mobile': 'Добавить',
  'productLog.title': 'Обновления продукта',
  'security.features.title': 'Функции безопасности',
  'security.features.localDecryption.title': 'Локальная расшифровка',
  'security.features.localDecryption.description': 'Все операции расшифровки выполняются локально в вашем браузере, содержимое файла и пароль никогда не покидают ваше устройство',
  'security.features.militaryEncryption.title': 'Военное шифрование',
  'security.features.militaryEncryption.description': 'Использует алгоритм шифрования AES-256-CBC, самый безопасный стандарт симметричного шифрования, способный противостоять всем известным атакам',
  'security.features.privacyProtection.title': 'Защита конфиденциальности',
  'security.features.privacyProtection.description': 'Строгий механизм защиты конфиденциальности, пароли расшифровки не сохраняются, содержимое файлов не записывается',
  'security.features.smartDecryption.title': 'Умная блочная расшифровка',
  'security.features.smartDecryption.description': 'Технология умной блочной расшифровки значительно повышает скорость расшифровки при снижении использования памяти',
  'security.features.learnMore': 'Узнать больше',
  'security.features.modal.title': 'Подробности о функциях безопасности',
  'security.features.modal.close': 'Закрыть',
  'decrypt.security.modal.title': 'Уведомление безопасности',
  'decrypt.security.modal.description': 'Все операции расшифровки выполняются локально, ваш пароль и содержимое файла никогда не отправляются на сервер',
  'decrypt.security.modal.vip.title': 'Как VIP-пользователь, вы можете:',
  'decrypt.security.modal.vip.feature1': 'Расшифровывать файлы любого размера',
  'decrypt.security.modal.vip.feature2': 'Использовать умную блочную расшифровку для лучшей эффективности',
  'decrypt.security.modal.vip.feature3': 'Поддерживать пакетную расшифровку больших файлов',
  'decrypt.security.modal.free.title': 'Важно: Процесс расшифровки требует примерно в 3 раза больше памяти браузера, чем размер файла.',
  'decrypt.security.modal.free.feature1': 'Бесплатные пользователи ограничены 4GB на файл',
  'decrypt.security.modal.free.feature2': 'Обновитесь до VIP для расшифровки файлов любого размера',
  'decrypt.security.modal.free.feature3': 'Если браузер зависает, рассмотрите обновление до VIP для использования блочной расшифровки',
  'security.diagram.plaintext.block1': 'Блок открытого текста 1',
  'security.diagram.plaintext.block2': 'Блок открытого текста 2',
  'security.diagram.ciphertext.block1': 'Блок зашифрованного текста 1',
  'security.diagram.ciphertext.block2': 'Блок зашифрованного текста 2',
  'security.diagram.key': 'Ключ',
  'security.diagram.aes.encryption': 'Шифрование AES',
  'security.diagram.xor.operation': 'Операция XOR',
  'security.diagram.iv': 'Вектор инициализации',
  'decrypt.fileList.empty': 'Нет файлов, добавьте файлы для расшифровки',
  'decrypt.fileList.column.name': 'Имя файла',
  'decrypt.fileList.column.size': 'Размер',
  'decrypt.fileList.column.status': 'Статус',
  'decrypt.fileList.column.actions': 'Действия',
  'decrypt.fileList.status.pending': 'Ожидание',
  'decrypt.fileList.status.decrypting': 'Расшифровка',
  'decrypt.fileList.status.success': 'Завершено',
  'decrypt.fileList.status.error': 'Ошибка',
  'decrypt.fileList.action.info': 'Инфо',
  'decrypt.password.modal.title': 'Введите пароль расшифровки',
  'decrypt.password.modal.placeholder': 'Введите пароль',
  'decrypt.password.modal.hint': 'Введите пароль, установленный при шифровании, он будет использован только для локальной расшифровки',
  'decrypt.message.invalidFile': 'Выберите только файлы .encrypted',
  'decrypt.message.duplicate': 'Файл "{filename}" уже существует, дубликат автоматически удален',
  'decrypt.message.oversizeTitle': 'Превышен размер файла',
  'decrypt.message.oversizeContent': 'Следующие файлы превышают бесплатный лимит (4GB):',
  'decrypt.message.oversizeHint': 'Обновитесь до VIP для расшифровки файлов любого размера',
  'decrypt.message.selectFile': 'Выберите файлы для расшифровки',
  'decrypt.message.enterPassword': 'Введите пароль расшифровки',
  'decrypt.message.decryptSuccess': 'Файл {filename} сохранен',
  'decrypt.message.saveCancel': 'Сохранение файла {filename} отменено',
  'decrypt.message.downloadSuccess': 'Файл {filename} сохранен в папку загрузок',
  'decrypt.message.decryptError': 'Ошибка расшифровки файла {filename}: {error}',
  'decrypt.message.batchError': 'Ошибка пакетной расшифровки, попробуйте снова',
  'common.unknown': 'Неизвестно',
  'common.speed': 'Скорость',
  'common.timeSpent': 'Затраченное время',
  'common.remaining': 'Осталось',
  'sideMenu.storageInfo.title': 'Объем хранилища',
  'sideMenu.storageInfo.usage': 'Использовано {used} / Всего {total}',
  'sideMenu.storageStats.title': 'Статистика хранилища',
  'sideMenu.storageStats.overview': 'Обзор',
  'sideMenu.storageStats.totalFiles': 'Всего файлов',
  'sideMenu.storageStats.totalSize': 'Общий размер',
  'sideMenu.storageStats.fileTypes': 'Распределение типов файлов',
  'sideMenu.storageStats.providers': 'Поставщики услуг',
  'common.default': 'По умолчанию',
  'common.regionCode': 'Код региона',
  'common.nodeType': 'Тип узла',
  'common.storageUsed': 'Использовано',
  'common.storageAvailable': 'Доступно',
  'common.storageLimit': 'Общая емкость',
  'common.storageUsageDetail': 'Использовано {used} / Всего {total}',
  'common.defaultNode': 'Узел по умолчанию',
  'common.confirm': 'Подтвердить',
  'common.cancel': 'Отмена',
  'common.latency': 'Задержка',
  'common.retry': 'Повторить',
  'cloudDrive.nodeSelect.title': 'Выбрать узел хранения',
  'cloudDrive.nodeSelect.addNode': 'Добавить узел хранения',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Подтвердите удаление узла',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Вы уверены, что хотите удалить узел "{nodeName}"? Это действие нельзя отменить!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Узел успешно удален',
  'cloudDrive.nodeSelect.deleteFailed': 'Не удалось удалить узел',
  
  // Создание узла
  'cloudDrive.nodeCreate.title': 'Добавить узел хранения',
  'cloudDrive.nodeCreate.selectProvider': 'Выберите облачного провайдера',
  'cloudDrive.nodeCreate.nodeName': 'Имя узла',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Оставьте пустым для использования имени по умолчанию',
  'cloudDrive.nodeCreate.nameMaxLength': 'Имя узла не может превышать 50 символов',
  'cloudDrive.nodeCreate.noProviders': 'Нет доступных облачных провайдеров',
  'cloudDrive.nodeCreate.pingLatency': 'Задержка {value} мс',
  'cloudDrive.nodeCreate.pingTesting': 'Тестирование задержки...',
  'cloudDrive.nodeCreate.pingFailed': 'Ошибка теста задержки',
  'cloudDrive.nodeCreate.pingUnavailable': 'Тест задержки недоступен',
  'cloudDrive.nodeCreate.sortByLatency': 'Сортировать по задержке',
  'cloudDrive.nodeCreate.selectRegion': 'Выбрать регион',
  'cloudDrive.nodeCreate.selectedRegion': 'Выбранный регион',
  'cloudDrive.nodeCreate.noRegions': 'Нет доступных регионов',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Пожалуйста, выберите облачного провайдера',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Пожалуйста, сначала выберите облачного провайдера',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Пожалуйста, сначала выберите регион',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Ошибка загрузки списка облачных провайдеров',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Ошибка загрузки списка регионов',
  'cloudDrive.nodeCreate.nodeType': 'Тип узла',
  'cloudDrive.nodeCreate.nodeType.standard': 'Стандартное хранилище',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Хранилище низкой частоты',
  'cloudDrive.nodeCreate.nodeType.archive': 'Архивное хранилище',
  'cloudDrive.nodeCreate.storageLimit': 'Лимит хранилища',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Пожалуйста, введите лимит хранилища',
  'cloudDrive.nodeCreate.storageLimitMin': 'Лимит хранилища не может быть меньше 1 ГБ',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Введите лимит хранилища (ГБ)',
  'cloudDrive.nodeCreate.success': 'Узел хранения успешно создан',
  'cloudDrive.nodeCreate.failed': 'Не удалось создать узел хранения',
  
  // Редактирование узла
  'cloudDrive.nodeEdit.title': 'Редактировать узел',
  'cloudDrive.nodeEdit.name': 'Имя узла',
  'cloudDrive.nodeEdit.nameRequired': 'Пожалуйста, введите имя узла',
  'cloudDrive.nodeEdit.nameMaxLength': 'Имя узла не может превышать 50 символов'
}; 